import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { NavigateFunction } from "react-router-dom";
import { AdmPanelContainer } from "../../../../adm-panel/site/api/screens";
import { SubscriptionStatementPageControllerImpl, SubscriptionStrings } from "../../../business";
import { SubscriptionStatementDataResponse } from "../../interfaces";
import { SubscriptionStatementPageFactoryImpl } from "../factories";

interface SubscriptionPage {
    navigate: NavigateFunction,
}

export const SubscriptionStatementPage: React.FC<SubscriptionPage> = ({ navigate }) => {
    const strings = SubscriptionStrings['PTBR'].statement;
    const [isLoading, setLoading] = useState<Boolean>(true);
    const [plansData, setPlansData] = useState<SubscriptionStatementDataResponse>();

    const factory = new SubscriptionStatementPageFactoryImpl();
    const controller = new SubscriptionStatementPageControllerImpl();

    const fetchData = async () => {
        try {
            const response = await controller.onLoad();
            if (response.response.data.length === 0) {
                setLoading(false);
                return false;
            }
            setLoading(false);
            setPlansData(response);
        } catch (error) {
            console.error("Erro na requisição:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const content =
        <> <h4 className="mb-4">{strings.title}</h4>
            <Card>
                <Card.Body>
                    {isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(plansData)}
                </Card.Body>
            </Card>
        </>

    return <AdmPanelContainer children={content} />
}
